<template>
  <div class="longPic">
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item>
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="add"
            v-if="menuPerm('zidingyiPage:insert')"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-loading="loading" style="margin-top: 15px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="title" label="标题" align="center" width="300">
          <template slot-scope="{ row }">
            <a :title="row.title">{{ row.title }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="zhaiyao" label="摘要" align="center" width="300">
          <template slot-scope="{ row }">
            <a :title="row.zhaiyao">{{ row.zhaiyao }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="pcImgUrl"
          label="长图"
          width="150px"
          height="300px"
          align="center"
        >
          <template slot-scope="{ row }">
            <viewer :images="photo">
              <img
                :src="row.oss_url"
                :key="row.id"
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          prop="pcImgUrl"
          label="封面图"
          width="150px"
          height="300px"
          align="center"
        >
          <template slot-scope="{ row }">
            <viewer :images="photo">
              <img
                :src="row.cover_url"
                :key="row.id"
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column label="链接" prop="linkTo" width="150px">
          <!-- 'http://192.168.0.101/zdyPage?id=' + row.id -->
          <!-- 'https://www.weiguanzixun.com/zdyPage?id=' + row.id -->
          <template slot-scope="{ row }">
            <el-button
              @click="copy"
              style="margin-left: 35px"
              type="primary"
              size="mini"
              class="btns"
              :data-clipboard-text="
                'https://www.weiguanzixun.com/zdyPage?id=' + row.id
              "
              >复制</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeList(row)"
                v-if="menuPerm('zidingyiPage:update')"
                :disabled="
                  (row.examineStatus == 1 || row.examineStatus == 3) && allOpen
                    ? true
                    : false
                "
                >修改</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="deleteList(row.id)"
                v-if="menuPerm('zidingyiPage:delete')"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
    <!-- 修改页面 -->
    <a-drawer
      title="长图广告详情页"
      :width="1000"
      :visible="changevisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Change :Changedata="changeData" />
    </a-drawer>
  </div>
</template>
<script>
import Change from "./change";
import Clipboard from "clipboard";
export default {
  components: {
    Change,
  },
  data() {
    return {
      delOpen: false,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      list: [],
      loading: false,
      changevisible: false,
      changeData: [],
      photo: [],
      deleteId: "",
    };
  },
  methods: {
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/zidingyiPage/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList();
          this.delOpen = false;
        }
      });
    },
    deleteList(id) {
      this.deleteId = id;
      this.delOpen = true;
    },
    add() {
      this.$router.push("/longPicAdd");
    },
    // 修改
    changeList(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    onClose() {
      this.changevisible = false;
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.postAxios("/zidingyiPage/list", {
        pageNum: this.currentPage,
        pageSize: 10,
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.list.map((i) => {
            this.photo.push(i.oss_url);
          });
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.longPic {
  width: 95%;
  height: auto;
  margin: 20px auto;
}
a {
  color: #606266;
}
</style>